import { AudienceCriteria } from "@appTypes/digital-audience/DigitalAudience";
import { DigitalAudienceInsightsActions, DigitalAudienceInsightsActionsType } from "./DigitalAudienceInsightsActions";

export type DigitalAudienceInsightsState = {
  modal: {
    isInsightsModalOpened: boolean,
    isSavingAudience: boolean,
    totalAudience: number, 
    adAccount: any,
    audienceSelections: string,
    franchises: string,
    platform: string,
    selectedCriteria: AudienceCriteria[],
    storeCode: string | null
  }
};

const digitalAudienceInsightsState = (): DigitalAudienceInsightsState => ({
  modal: {
    isInsightsModalOpened: false,
    isSavingAudience: false,
    totalAudience: 0,
    adAccount: null,
    audienceSelections: '',
    franchises: '',
    platform: '',
    selectedCriteria: [],
    storeCode: null
  }
});

export const digitalAudienceInsightsReducer = (
  state: DigitalAudienceInsightsState = digitalAudienceInsightsState(),
  action: DigitalAudienceInsightsActions
): DigitalAudienceInsightsState => {

  switch (action.type) {
    case DigitalAudienceInsightsActionsType.SET_DIGITAL_AUDIENCE_INSIGHTS_MODAL_OPENED: {
      return {
        ...state,
        modal: {
          ...state.modal,
          isInsightsModalOpened: action.payload.isOpened
        }        
      }
    }

    case DigitalAudienceInsightsActionsType.SET_DIGITAL_AUDIENCE_INSIGHTS_ISSAVINGAUDIENCE: {
      return {
        ...state,
        modal: {
          ...state.modal,
          isSavingAudience: action.payload.isSavingAudience
        }        
      }
    }    

    case DigitalAudienceInsightsActionsType.SET_DIGITAL_AUDIENCE_INSIGHTS_MODAL_STATE: {
      return {
        ...state,
        modal: {
          ...state.modal,
          totalAudience: action.payload.totalAudience,
          adAccount: action.payload.adAccount,
          audienceSelections: action.payload.audienceSelections,
          franchises: action.payload.franchises,
          platform: action.payload.platform,
          selectedCriteria: action.payload.selectedCriteria,
          storeCode: action.payload.storeCode
        }
      }
    }
        
    default:
      return state;
  }
};